import React from 'react';
import { motion } from 'framer-motion';
import { TicketIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/116niX6vUuDsZhwpFcqbm8/VU_HeroPhoto_Poolside_Clean_v2.png';
export function Hero() {
  return <header id="top" className="relative w-full min-h-[calc(100svh-64px)] overflow-hidden bg-[var(--vu-black)]" data-id="element-42" data-mp="9lbfcytwl7cj">
      <div className="absolute inset-0 z-0" data-id="element-43" data-mp="4jm4pkalevoz">
        <img src={HERO_IMG} alt="The four Virtually Unknown band members performing poolside by the water" className="h-full w-full object-cover object-[center_30%]" data-id="element-44" data-mp="12a0j75mcfqrz" />
        {/* Soft contrast zones sit only in the open canopy and crossing; all four faces remain unobstructed. */}
        <div className="absolute inset-x-0 top-0 h-[38%] bg-gradient-to-b from-[var(--vu-black)]/58 via-[var(--vu-black)]/22 to-transparent" data-id="element-45" data-mp="nb6njukxbpp7" />
        <div className="absolute inset-x-0 bottom-0 h-[34%] bg-gradient-to-t from-[var(--vu-black)] via-[var(--vu-black)]/84 to-transparent" data-id="element-46" data-mp="3cz5uuafyvxzt" />
      </div>

      <div className="relative z-10 flex min-h-[calc(100svh-64px)] flex-col justify-between px-5 py-7 sm:px-8 sm:py-10" data-id="element-47" data-mp="3j9k7h1pgwzbd">
        {/* Positioned in the open sky above the band. */}
        <motion.div initial={{
        opacity: 0,
        y: -14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="mx-auto w-full max-w-4xl pt-1 text-center" data-id="element-48" data-mp="39b4hj226fw3g">
          <h1 className="font-display -rotate-1 text-4xl uppercase leading-[0.88] tracking-[0.02em] text-[var(--vu-red)] [text-shadow:3px_3px_0_var(--vu-navy),-1px_-1px_0_var(--vu-gold),1px_-1px_0_var(--vu-gold),-1px_1px_0_var(--vu-gold),1px_1px_0_var(--vu-gold)] sm:text-6xl md:text-7xl" data-id="element-49" data-mp="30gq4z7916zo1">
            Virtually Unknown
          </h1>
          <p className="mx-auto mt-3 inline-block rounded-full bg-[var(--vu-black)]/92 px-4 py-1.5 font-cond text-sm uppercase tracking-[0.3em] text-[var(--vu-cream)] sm:text-base" data-id="element-50" data-mp="2hj5clq725iyo">
            Old Dogs. New Tricks.
          </p>
        </motion.div>

        {/* Low information panel is reserved for the water/patio, away from all faces. */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.12,
        duration: 0.55,
        ease: 'easeOut'
      }} className="mx-auto w-full max-w-2xl border-y border-[var(--vu-gold)]/65 bg-[var(--vu-black)]/78 px-5 py-5 text-center shadow-[0_10px_30px_rgba(0,0,0,0.25)] backdrop-blur-[2px] sm:px-9" data-id="element-51" data-mp="najg5kfzo7df">
          <p className="font-cond text-xs uppercase tracking-[0.34em] text-[var(--vu-gold)] sm:text-sm" data-id="element-52" data-mp="161jal16969e3">
            St. Pete Beach · Florida
          </p>
          <p className="mt-2 font-body text-sm text-[var(--vu-cream)]/80 sm:text-base" data-id="element-53" data-mp="114ssy9esv5qk">
            Classic Rock · Acoustic · Pop · Rock
          </p>
          <div className="mt-5" data-id="element-54" data-mp="3lu04j5ufbd1u">
            <a href="#shows" className="group inline-flex items-center gap-3 border-2 border-[var(--vu-gold)] bg-[var(--vu-red)] px-8 py-4 font-display text-lg uppercase tracking-wider text-[var(--vu-cream)] shadow-[5px_5px_0_0_var(--vu-black)] transition-all hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0_0_var(--vu-black)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" data-id="element-55" data-mp="3lu9x916uryb8">
              <TicketIcon className="h-5 w-5" data-id="element-56" data-mp="2b2sk48edxpw9" />
              Catch Us Live
            </a>
          </div>
        </motion.div>
      </div>
    </header>;
}